import {ErrorApi} from 'mc/lib/utils';
import {browserHistory} from 'react-router';

ErrorApi.addResolveMiddleware(e => {
    if (e.status === 401) {
        browserHistory.replace(serverContextPath + '/welcome');
        return null;
    }
    return e;
});

export default ErrorApi;
